<template>
  <div class="container fluid">
    <Datatable></Datatable>
  </div>
</template>

<script>
import Datatable from "@/components/DatatableContratos.vue"

export default {
  name: "EstadoContratos",
  data: () => ({
 
    
  }),
  components: {
    Datatable
  },

};
</script>
